module.exports = __webpack_public_path__ + "img/history-v2.b0474c60.svg";